/* Extends Habitat's existing modal only for the Nike/Jordan size guide. */
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-nike-jordan-guide]').forEach((modal) => {
      if (modal.dataset.sizeGuideInitialized === 'true') return;

      const opener = document.querySelector(`[data-modal="#${modal.id}"] button`);
      const close = modal.querySelector('[id^="ModalClose-"]');
      const tabs = [...modal.querySelectorAll('[role="tab"]')];
      const panels = tabs.map((tab) => modal.querySelector(`#${tab.getAttribute('aria-controls')}`));
      if (!opener || !close || tabs.length !== 2 || panels.some((panel) => !panel)) return;
      modal.dataset.sizeGuideInitialized = 'true';

      const selectTab = (index, focusTab = false) => {
        tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panels[tabIndex].hidden = !selected;
        });
        if (focusTab) tabs[index].focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(index));
        tab.addEventListener('keydown', (event) => {
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === undefined) return;
          event.preventDefault();
          selectTab(nextIndex, true);
        });
      });

      // Habitat has no open event. Move focus into this modal after its opener's click.
      const nativeShow = modal.show;
      modal.show = function (trigger) {
        nativeShow.call(this, trigger);
        opener.setAttribute('aria-expanded', 'true');
      };

      const focusClose = () => {
        if (modal.hasAttribute('open') && !modal.contains(document.activeElement)) {
          close.focus();
        }
      };
      opener.addEventListener('click', focusClose);
      opener.addEventListener('keyup', (event) => {
        if (event.key === 'Enter' || event.key === ' ') focusClose();
      });

      // The theme transitions visibility, so a hidden modal cannot receive
      // focus until its opening transition has completed.
      modal.addEventListener('transitionend', (event) => {
        if (event.target === modal) focusClose();
      });
      opener.addEventListener('keydown', (event) => {
        if (!modal.hasAttribute('open')) return;
        if (event.key === 'Tab') {
          event.preventDefault();
          focusClose();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          modal.hide();
        }
      });

      // The native X button binds hide() in its constructor, so observe the
      // open attribute to restore focus for X, Escape, and backdrop alike.
      new MutationObserver(() => {
        if (modal.hasAttribute('open')) return;
        opener.setAttribute('aria-expanded', 'false');
        opener.focus({ preventScroll: true });
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });

      modal.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !modal.hasAttribute('open')) return;
        const focusable = [...modal.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')]
          .filter((element) => element.getClientRects().length > 0);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  };

  customElements.whenDefined('modal-dialog').then(initialize);
})();
